// extracted by mini-css-extract-plugin
module.exports = {"target":"DownloadCsvPage__target--2GbGp","period":"DownloadCsvPage__period--2UeL4","detail":"DownloadCsvPage__detail--31Wdy"};